import { API_URL } from '../config.js';
import { toApiError } from '../lib/api-error';

export type AuthFetch = (input: string | URL | Request, init?: RequestInit) => Promise<Response>;

export type AuthRequestOptions = {
  apiUrl?: string;
  fetchFn?: AuthFetch;
};

export type SwitchOrganizationOptions = AuthRequestOptions & {
  orgId: string;
};

const defaultFetch: AuthFetch = (input, init) => fetch(input, init);

export async function switchOrganizationRequest({
  orgId,
  apiUrl = API_URL,
  fetchFn = defaultFetch,
}: SwitchOrganizationOptions): Promise<unknown> {
  const response = await fetchFn(`${apiUrl}/organizations/${orgId}/switch`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!response.ok) throw await toApiError(response, 'Failed to switch organization');
  return response.json() as Promise<unknown>;
}

export type SetDefaultOrganizationOptions = AuthRequestOptions & {
  orgId: string;
};

export async function setDefaultOrganizationRequest({
  orgId,
  apiUrl = API_URL,
  fetchFn = defaultFetch,
}: SetDefaultOrganizationOptions): Promise<unknown> {
  const response = await fetchFn(`${apiUrl}/organizations/${orgId}/default`, {
    method: 'PUT',
    credentials: 'include',
  });
  if (!response.ok) throw await toApiError(response, 'Failed to set default organization');
  return response.json() as Promise<unknown>;
}
